<template>
    <b-tabs
        class="apprentice-pills-tab admin-tab"
        v-model="activeTab"
        pills
        vertical
        nav-wrapper-class="col-12 col-lg-3 col-xl-2 d-none d-lg-block"
        content-class="col-12 col-lg-9 col-xl-10 admin-tab-content"
        @input="updateTabIndex">
        <div class="admin-sub-item-nav d-flex d-lg-none">
            <b-form-select
                class="apprentice-primary-select"
                v-model="activeTab"
                :options="options"></b-form-select>
        </div>

        <b-tab
            title-item-class="admin-tab-item"
            title-link-class="admin-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-fw fa-arrow-right"></i>{{ $t('internship.move') }}</div>
                </div>
            </template>

            <design-2021-project-show-teacher-change-group-component
                :project-in="projectIn"></design-2021-project-show-teacher-change-group-component>
        </b-tab>
    </b-tabs>
</template>

<script>
export default {
    name: 'design-2021-internship-report-show-teacher-component',
    props: ['projectIn'],
    data() {
        return {
            activeTab: 0,
            options: [{ value: 0, text: this.$t('internship.move') }],
        };
    },

    methods: {
        updateTabIndex(tabIndex) {
            localStorage.setItem('portfolioTeacherTab', tabIndex);
        },
    },

    created() {
        if (localStorage.getItem('portfolioTeacherTab')) {
            this.activeTab = parseInt(localStorage.getItem('portfolioTeacherTab'));
        }
    },
};
</script>

<style scoped lang="scss">
.admin-sub-item-nav {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    display: flex;
    align-items: center;
    justify-content: flex-end;

    select {
        width: auto;
        border: 1px solid $primary;
    }
}
</style>
